<section class="surface-section">
  <div class="feature-container py-8 px-3 md:px-4 lg:px-5 text-center">
    <!-- Título -->
    <div class="mb-3 font-bold text-3xl">
      <span class="text-900">Por qué comprar en Implementos</span>
      <!-- <span class="text-blue-600">Implementos?</span> -->
    </div>
    <!-- Descripción  -->
    <div class="text-700 mb-6">
      Simplifique todo el proceso de compra, desde la búsqueda hasta la
      entrega, todo en una sola plataforma.
    </div>
    <!-- Características -->
    <div class="grid">
      <div class="col-12 md:col-4 mb-4 px-5">
        <span
          class="p-3 shadow-2 mb-3 inline-block surface-card"
          style="border-radius: 10px"
        >
          <i class="pi pi-credit-card text-4xl text-blue-500"></i>
        </span>
        <div class="text-900 text-xl mb-3 font-medium">Elige cómo pagar</div>
        <span class="text-700 line-height-3"
          >Paga con tus tarjetas de débito y crédito o hazlo con efectivo en
          puntos de pago.</span
        >
      </div>
      <div class="col-12 md:col-4 mb-4 px-5">
        <span
          class="p-3 shadow-2 mb-3 inline-block surface-card"
          style="border-radius: 10px"
        >
          <i class="pi pi-box text-4xl text-blue-500"></i>
        </span>
        <div class="text-900 text-xl mb-3 font-medium">
          Envío gratis desde $ 59.990
        </div>
        <span class="text-700 line-height-3"
          >Con solo estar registrado en Implementos, tienes envíos gratis en
          millones de productos seleccionados..</span
        >
      </div>
      <div class="col-12 md:col-4 mb-4 px-5">
        <span
          class="p-3 shadow-2 mb-3 inline-block surface-card"
          style="border-radius: 10px"
        >
          <i class="pi pi-shield text-4xl text-blue-500"></i>
        </span>
        <div class="text-900 text-xl mb-3 font-medium">Compra protegida</div>
        <span class="text-700 line-height-3"
          >Completa tus compras en Implementos para que estén siempre
          protegidas. Si el producto no es lo que esperabas o no llega, te
          devolvemos tu dinero.</span
        >
      </div>
    </div>
  </div>
</section>
